<script setup></script>

<template>
  <div
    class="mt-10 flex flex-1 flex-col items-center justify-center px-6 py-12 lg:px-8 overflow-hidden"
  >
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <img
        class="mx-auto h-14 w-auto"
        src="@/assets/images/ytz-logo.svg"
        alt="YTZ company logo"
      />
      <h2 class="mt-10 text-center text-2xl font-medium">
        Thanks for signing up!
      </h2>
      <p class="text-center mt-4">
        Your registration has been received. <br />Check your inbox for further
        instructions.
      </p>
    </div>

    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <p class="mt-8 text-center">
        Return to the
        <a
          href="https://ytz.com"
          class="font-semibold leading-6 text-accent hover:text-accent/80"
        >
          Homepage
        </a>
      </p>
    </div>
  </div>
</template>
